import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import ImageFigure from '../UI/Image/ImageFigure';
import Paragraph from '../UI/Paragraph';

const PciDssInfo = ({ entity, isDesktop }) => {
  return (
    <div className="Payment__Pci-Dss-info-container__list">
      {entity.img ? (
        <ImageFigure
          className="Payment__Pci-Dss-info-container__list__img"
          src={entity.img}
          alt="img"
        />
      ) : null}
      {entity.title ? (
        <Paragraph className="Payment__Pci-Dss-info-container__list__title">
          {entity.title}
        </Paragraph>
      ) : null}
      {entity.text ? (
        <div className="Payment__Pci-Dss-info-container__list__text">
          {ReactHtmlParser(entity.text)}
        </div>
      ) : null}
    </div>
  );
};

export default PciDssInfo;

PciDssInfo.propTypes = {
  entity: PropTypes.shape({}),
  isDesktop: PropTypes.bool,
};

PciDssInfo.defaultProps = {
  entity: null,
  isDesktop: null,
};
